import React from "react";
import { Box, List, Text, useMantineTheme } from "@mantine/core";
import { ScenarioEventInputData } from "../../../../types/assessments";

interface IEventParameters {
	eventInformation: ScenarioEventInputData;
}

export const EventParameters: React.FC<IEventParameters> = ({ eventInformation }) => {
	const theme = useMantineTheme();
	const parametersWithPriorityList = ["target_priority_list"];

	return (
		<div>
			<Text
				c={theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6]}
				style={{ fontSize: "0.875rem", marginBottom: 4 }}
				fw={500}
			>
				Parameters
			</Text>

			<Box pl="sm">
				{Object.entries(eventInformation.parameters || {}).map(([key, value]) => (
					<Box key={key} mb={4}>
						<Text size="xs" fw={500} c="dimmed" style={{ fontWeight: "bold" }}>
							{key}:
						</Text>

						{Array.isArray(value) ? (
							<List
								style={{ margin: 0, paddingLeft: "1rem" }}
								type={
									parametersWithPriorityList.includes(key) || key.toLowerCase().includes("priority")
										? "ordered"
										: "unordered"
								}
								sx={{ "& .mantine-List-item::marker": { color: theme.colors.red[5] } }}
							>
								{value.map((item, idx) => (
									<List.Item key={idx}>
										<Text size="xs" c="dimmed">
											{item}
										</Text>
									</List.Item>
								))}
							</List>
						) : (
							<Text size="xs" c="dimmed" pl="sm">
								{value ? value.toString() : "No data"}
							</Text>
						)}
					</Box>
				))}
			</Box>
		</div>
	);
};
